export default "__VITE_ASSET__DtLHz8F$__"